import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.77 8.032C6.429 9.042 5.25 10.43 4.42 11.92l-.611-.34.612.34a.165.165 0 0 0 0 .16 12.75 12.75 0 0 0 2.943 3.566L9.12 13.89a3.339 3.339 0 0 1 .435-4.295 3.526 3.526 0 0 1 4.313-.453l1.619-1.619C14.352 6.821 13.159 6.42 12 6.42c-1.416 0-2.883.6-4.23 1.613ZM16.5 6.51c-1.371-.907-2.916-1.491-4.5-1.491-1.807 0-3.563.76-5.07 1.894C5.417 8.049 4.112 9.59 3.196 11.24a1.564 1.564 0 0 0 0 1.518v.001A14.177 14.177 0 0 0 6.37 16.64l-1.146 1.146a.7.7 0 0 0 .99.99L18.776 6.214a.7.7 0 0 0-.99-.99L16.5 6.51Zm-3.666 3.667a2.125 2.125 0 0 0-2.302.421 1.939 1.939 0 0 0-.392 2.272l2.694-2.693Zm4.738-1.96a.7.7 0 0 1 .99.013c.877.9 1.641 1.931 2.241 3.011a1.564 1.564 0 0 1 0 1.518v.001c-.916 1.65-2.222 3.191-3.732 4.327-1.508 1.134-3.264 1.894-5.071 1.894-1.02 0-2.023-.243-2.971-.655a.7.7 0 1 1 .558-1.284c.803.35 1.616.54 2.413.54 1.416 0 2.883-.601 4.23-1.614 1.342-1.01 2.521-2.398 3.35-3.888l.611.34-.612-.34a.165.165 0 0 0 0-.16 12.924 12.924 0 0 0-2.02-2.713.7.7 0 0 1 .013-.99Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
